import React from 'react';
export const renderRawHTML = rawHTML => React.createElement("div", { dangerouslySetInnerHTML: { __html: decodeURIComponent(rawHTML) } });
